import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  it: {
    translation: {
      nav: { home: "Home", menu: "Menu", gallery: "Galleria", reservation: "Prenota", quote: "Eventi", location: "Dove Siamo", vicenza: "Da vedere", careers: "Lavora con noi", admin: "Admin" },
      hero: {
        eyebrow: "Nel cuore di Vicenza",
        title: "Eleganza,\ngusto, convivialità.",
        subtitle: "Cucina italiana raffinata e cocktail d'autore in Piazza Andrea Palladio. Un'esperienza dove tradizione e modernità si incontrano.",
        ctaMenu: "Scopri il Menu", ctaBook: "Prenota un Tavolo",
      },
      about: {
        eyebrow: "La nostra storia",
        title: "Un salotto a tavola.",
        body: "Harry's Salotto e Cucina è un locale accogliente nel cuore di Vicenza, dove eleganza e atmosfera conviviale si incontrano. Offriamo una cucina curata con piatti selezionati, accompagnati da cocktail classici e creativi e una selezione di vini di qualità. Ci distinguiamo per l'ambiente raffinato ma rilassato, ideale sia per cene intime che per momenti di convivialità.",
        feature1Title: "Cucina d'autore", feature1Body: "Piatti della tradizione veneta reinterpretati con eleganza.",
        feature2Title: "Cocktail & Vini", feature2Body: "Selezione di etichette pregiate e mixology contemporanea.",
        feature3Title: "Eventi privati", feature3Body: "Gruppi da 20, 30 o 40 persone in ambiente esclusivo.",
      },
      menu: {
        eyebrow: "La carta", title: "Il nostro menu",
        subtitle: "Una selezione che cambia con le stagioni. Spesa media: 20-30€ a persona.",
        categories: { antipasti: "Antipasti", primi: "Primi in padella", secondi: "Secondi", pizza: "Pizza in pala", burgers: "Burgers & Co", insalate: "Insalatone", contorni: "Contorni", dolci: "Dolci", cocktail: "Cocktail", vini: "Vini" },
        empty: "Nessun piatto in questa categoria al momento.",
      },
      reservation: {
        eyebrow: "Prenotazione", title: "Prenota un tavolo",
        subtitle: "Compila il modulo: alla conferma si aprirà WhatsApp con la tua richiesta già pronta da inviare.",
        viaWhatsapp: "Tutto tramite WhatsApp",
        tabBook: "Prenota tavolo",
        tabQuote: "Eventi privati",
        name: "Nome e cognome", email: "Email", phone: "Telefono", date: "Data", time: "Orario",
        guests: "Ospiti", notes: "Note (allergie, preferenze...)",
        submit: "Invia su WhatsApp", success: "WhatsApp aperto: invia il messaggio per confermare.",
        error: "Errore nell'invio. Riprova.", required: "Campo obbligatorio",
      },
      quote: {
        eyebrow: "Eventi privati", title: "Richiedi un preventivo",
        subtitle: "Cene aziendali, compleanni, anniversari. Menu concordato per gruppi da 20 a 40 persone.",
        name: "Nome e cognome", email: "Email", phone: "Telefono",
        eventType: "Tipo di evento", eventTypes: { birthday: "Compleanno", corporate: "Aziendale", anniversary: "Anniversario", wedding: "Matrimonio", other: "Altro" },
        guests: "Numero ospiti", date: "Data evento", budget: "Budget orientativo (€/persona)",
        preferences: "Preferenze culinarie, allergie, richieste particolari",
        submit: "Invia su WhatsApp", success: "WhatsApp aperto: invia il messaggio per ricevere il preventivo.",
      },
      location: {
        eyebrow: "Dove siamo", title: "Vicenza, città del Palladio",
        subtitle: "A pochi passi dai principali monumenti UNESCO. Esplora la città dopo cena.",
        address: "Indirizzo", phone: "Telefono", hours: "Orari",
        attractions: "Attrazioni vicine", openInMaps: "Apri in Maps",
      },
      footer: { rights: "Tutti i diritti riservati", contact: "Contatti", links: "Link" },
      gallery: {
        eyebrow: "Galleria",
        title: "Piatti dal nostro menu.",
      },
      galleria: {
        eyebrow: "Galleria fotografica",
        title: "L'esperienza Harry's.",
        subtitle: "Ambiente, piatti, dettagli. Sfoglia le nostre foto e immergiti nell'atmosfera del locale.",
        empty: "Galleria in arrivo.",
      },
      reviews: {
        eyebrow: "Recensioni",
        title: "Dicono di noi.",
        subtitle: "Le voci dei nostri ospiti su Google e Tripadvisor: chi è venuto torna a trovarci.",
        basedOn: "recensioni",
        readOnGoogle: "Leggi su Google",
        readOnTripadvisor: "Leggi su Tripadvisor",
      },
      vicenza: {
        eyebrow: "Da vedere a Vicenza",
        title: "La città del Palladio.",
        subtitle: "Un itinerario di gioielli UNESCO a pochi passi dal nostro tavolo. Lasciati guidare dopo cena.",
        minutesAway: "min a piedi",
        readMore: "Approfondisci",
      },
      careers: {
        eyebrow: "Lavora con noi",
        title: "Unisciti al team Harry's.",
        subtitle: "Cerchiamo persone appassionate per la sala, la cucina e il bar. Inviaci la tua candidatura, ti ricontatteremo.",
        name: "Nome e cognome", email: "Email", phone: "Telefono",
        position: "Posizione di interesse",
        positions: { hall: "Sala", kitchen: "Cucina", bartender: "Bar / Mixology", sommelier: "Sommelier", other: "Altro" },
        message: "Presentati brevemente",
        cv: "Allega il tuo CV (PDF, DOC, max 5MB)",
        cvNote: "Dopo aver inviato il messaggio su WhatsApp, allega il tuo CV (PDF/DOC) come prossimo messaggio.",
        cvAttached: "CV allegato",
        cvRemove: "Rimuovi",
        viaWhatsapp: "Candidatura tramite WhatsApp",
        submit: "Invia su WhatsApp",
        success: "WhatsApp aperto: invia il messaggio e poi allega il tuo CV.",
        error: "Errore. Riprova più tardi.",
      },
      admin: {
        login: "Accesso amministratore", email: "Email", password: "Password", signin: "Accedi",
        invalid: "Credenziali non valide", logout: "Esci",
        dashboard: "Dashboard", menu: "Menu", reservations: "Prenotazioni", quotes: "Preventivi", careers: "Candidature",
        addItem: "Aggiungi piatto", editItem: "Modifica", deleteItem: "Elimina",
        category: "Categoria", price: "Prezzo", available: "Disponibile",
        save: "Salva", cancel: "Annulla", confirm: "Conferma eliminazione?",
        status: "Stato", pending: "In attesa", confirmed: "Confermato", rejected: "Rifiutato",
        empty: "Nessun elemento", details: "Dettagli", viewCv: "Vedi CV",
      },
    },
  },
  en: {
    translation: {
      nav: { home: "Home", menu: "Menu", gallery: "Gallery", reservation: "Book", quote: "Events", location: "Find Us", vicenza: "Discover Vicenza", careers: "Careers", admin: "Admin" },
      hero: {
        eyebrow: "In the heart of Vicenza",
        title: "Elegance,\ntaste, conviviality.",
        subtitle: "Refined Italian cuisine and signature cocktails on Piazza Andrea Palladio. Where tradition meets modernity.",
        ctaMenu: "Discover the Menu", ctaBook: "Book a Table",
      },
      about: {
        eyebrow: "Our story", title: "A living room at the table.",
        body: "Harry's Salotto e Cucina is a welcoming venue in the heart of Vicenza, where elegance and convivial atmosphere come together. We offer a curated kitchen with selected dishes, paired with classic and creative cocktails and a selection of quality wines.",
        feature1Title: "Signature cuisine", feature1Body: "Venetian tradition reinterpreted with elegance.",
        feature2Title: "Cocktails & Wines", feature2Body: "Premium labels and contemporary mixology.",
        feature3Title: "Private events", feature3Body: "Groups of 20, 30 or 40 in an exclusive setting.",
      },
      menu: {
        eyebrow: "The carte", title: "Our menu",
        subtitle: "A seasonal selection. Average spend: €20-30 per person.",
        categories: { antipasti: "Starters", primi: "Pasta dishes", secondi: "Mains", pizza: "Pizza", burgers: "Burgers & Co", insalate: "Salads", contorni: "Sides", dolci: "Desserts", cocktail: "Cocktails", vini: "Wines" },
        empty: "No items in this category yet.",
      },
      reservation: {
        eyebrow: "Reservation", title: "Book a table",
        subtitle: "Fill in the form: on submit, WhatsApp will open with your request ready to send.",
        viaWhatsapp: "Everything via WhatsApp",
        tabBook: "Book a table",
        tabQuote: "Private events",
        name: "Full name", email: "Email", phone: "Phone", date: "Date", time: "Time",
        guests: "Guests", notes: "Notes (allergies, preferences...)",
        submit: "Send via WhatsApp", success: "WhatsApp opened: send the message to confirm.",
        error: "Submission error. Please retry.", required: "Required field",
      },
      quote: {
        eyebrow: "Private events", title: "Request a quote",
        subtitle: "Corporate dinners, birthdays, anniversaries. Custom menu for groups of 20 to 40.",
        name: "Full name", email: "Email", phone: "Phone",
        eventType: "Event type", eventTypes: { birthday: "Birthday", corporate: "Corporate", anniversary: "Anniversary", wedding: "Wedding", other: "Other" },
        guests: "Number of guests", date: "Event date", budget: "Indicative budget (€/person)",
        preferences: "Culinary preferences, allergies, special requests",
        submit: "Request quote", success: "Request sent! We'll reply within 24h.",
      },
      location: {
        eyebrow: "Find us", title: "Vicenza, the Palladio's city",
        subtitle: "Steps away from major UNESCO landmarks. Explore the city after dinner.",
        address: "Address", phone: "Phone", hours: "Hours",
        attractions: "Nearby attractions", openInMaps: "Open in Maps",
      },
      footer: { rights: "All rights reserved", contact: "Contact", links: "Links" },
      gallery: {
        eyebrow: "Gallery",
        title: "Dishes from our kitchen.",
      },
      galleria: {
        eyebrow: "Photo gallery",
        title: "The Harry's experience.",
        subtitle: "Atmosphere, dishes, details. Browse our photos and step inside our space.",
        empty: "Gallery coming soon.",
      },
      reviews: {
        eyebrow: "Reviews",
        title: "What our guests say.",
        subtitle: "Voices of our guests on Google and Tripadvisor: those who came once keep coming back.",
        basedOn: "reviews",
        readOnGoogle: "Read on Google",
        readOnTripadvisor: "Read on Tripadvisor",
      },
      vicenza: {
        eyebrow: "Discover Vicenza",
        title: "The Palladio's city.",
        subtitle: "A trail of UNESCO jewels just steps from our table. Let yourself be guided after dinner.",
        minutesAway: "min walk",
        readMore: "Learn more",
      },
      careers: {
        eyebrow: "Careers",
        title: "Join the Harry's team.",
        subtitle: "We're looking for passionate people for the dining room, kitchen and bar. Send us your CV — we'll get back to you.",
        name: "Full name", email: "Email", phone: "Phone",
        position: "Position of interest",
        positions: { hall: "Dining room", kitchen: "Kitchen", bartender: "Bar / Mixology", sommelier: "Sommelier", other: "Other" },
        message: "Tell us about yourself",
        cv: "Attach your CV (PDF, DOC, max 5MB)",
        cvAttached: "CV attached",
        cvRemove: "Remove",
        submit: "Send application",
        success: "Application sent! We'll be in touch soon.",
        error: "Error. Please try again later.",
      },
      admin: {
        login: "Administrator login", email: "Email", password: "Password", signin: "Sign in",
        invalid: "Invalid credentials", logout: "Logout",
        dashboard: "Dashboard", menu: "Menu", reservations: "Reservations", quotes: "Quotes", careers: "Applications",
        addItem: "Add dish", editItem: "Edit", deleteItem: "Delete",
        category: "Category", price: "Price", available: "Available",
        save: "Save", cancel: "Cancel", confirm: "Confirm deletion?",
        status: "Status", pending: "Pending", confirmed: "Confirmed", rejected: "Rejected",
        empty: "No items", details: "Details", viewCv: "View CV",
      },
    },
  },
  de: {
    translation: {
      nav: { home: "Home", menu: "Speisekarte", gallery: "Galerie", reservation: "Reservieren", quote: "Events", location: "Anfahrt", vicenza: "Vicenza entdecken", careers: "Karriere", admin: "Admin" },      hero: {
        eyebrow: "Im Herzen von Vicenza",
        title: "Eleganz,\nGenuss, Geselligkeit.",
        subtitle: "Verfeinerte italienische Küche und kreative Cocktails an der Piazza Andrea Palladio. Wo Tradition auf Moderne trifft.",
        ctaMenu: "Speisekarte ansehen", ctaBook: "Tisch reservieren",
      },
      about: {
        eyebrow: "Unsere Geschichte", title: "Ein Salon bei Tisch.",
        body: "Harry's Salotto e Cucina ist ein einladendes Restaurant im Herzen von Vicenza, in dem Eleganz und gesellige Atmosphäre zusammenkommen. Wir bieten eine sorgfältig kuratierte Küche, klassische und kreative Cocktails sowie eine Auswahl edler Weine.",
        feature1Title: "Signature-Küche", feature1Body: "Venezianische Tradition mit Eleganz neu interpretiert.",
        feature2Title: "Cocktails & Weine", feature2Body: "Edle Etiketten und zeitgenössische Mixology.",
        feature3Title: "Private Events", feature3Body: "Gruppen von 20, 30 oder 40 Personen im exklusiven Rahmen.",
      },
      menu: {
        eyebrow: "Die Karte", title: "Unsere Speisekarte",
        subtitle: "Saisonale Auswahl. Durchschnittspreis: 20-30€ pro Person.",
        categories: { antipasti: "Vorspeisen", primi: "Pasta-Gerichte", secondi: "Hauptgänge", pizza: "Pizza", burgers: "Burgers & Co", insalate: "Salate", contorni: "Beilagen", dolci: "Desserts", cocktail: "Cocktails", vini: "Weine" },
        empty: "Keine Gerichte in dieser Kategorie.",
      },
      reservation: {
        eyebrow: "Reservierung", title: "Tisch reservieren",
        subtitle: "Formular ausfüllen: Beim Absenden öffnet sich WhatsApp mit Ihrer Anfrage zum direkten Versand.",
        viaWhatsapp: "Alles über WhatsApp",
        tabBook: "Tisch reservieren",
        tabQuote: "Private Events",
        name: "Vor- und Nachname", email: "E-Mail", phone: "Telefon", date: "Datum", time: "Uhrzeit",
        guests: "Gäste", notes: "Anmerkungen (Allergien, Wünsche...)",
        submit: "Auf WhatsApp senden", success: "WhatsApp geöffnet: Senden Sie die Nachricht zur Bestätigung.",
        error: "Übermittlungsfehler. Bitte erneut versuchen.", required: "Pflichtfeld",
      },
      quote: {
        eyebrow: "Private Events", title: "Angebot anfordern",
        subtitle: "Firmenessen, Geburtstage, Jubiläen. Maßgeschneidertes Menü für 20-40 Personen.",
        name: "Vor- und Nachname", email: "E-Mail", phone: "Telefon",
        eventType: "Event-Typ", eventTypes: { birthday: "Geburtstag", corporate: "Firmenfeier", anniversary: "Jubiläum", wedding: "Hochzeit", other: "Andere" },
        guests: "Anzahl Gäste", date: "Veranstaltungsdatum", budget: "Richtbudget (€/Person)",
        preferences: "Kulinarische Vorlieben, Allergien, Sonderwünsche",
        submit: "Auf WhatsApp senden", success: "WhatsApp geöffnet: Senden Sie die Nachricht für Ihr Angebot.",
      },
      location: {
        eyebrow: "Anfahrt", title: "Vicenza, die Stadt Palladios",
        subtitle: "Wenige Schritte von den UNESCO-Denkmälern. Entdecken Sie die Stadt nach dem Essen.",
        address: "Adresse", phone: "Telefon", hours: "Öffnungszeiten",
        attractions: "Sehenswürdigkeiten in der Nähe", openInMaps: "In Maps öffnen",
      },
      footer: { rights: "Alle Rechte vorbehalten", contact: "Kontakt", links: "Links" },
      gallery: {
        eyebrow: "Galerie",
        title: "Gerichte aus unserer Küche.",
      },
      galleria: {
        eyebrow: "Fotogalerie",
        title: "Das Harry's Erlebnis.",
        subtitle: "Ambiente, Gerichte, Details. Stöbern Sie in unseren Fotos und tauchen Sie in unsere Atmosphäre ein.",
        empty: "Galerie demnächst verfügbar.",
      },
      reviews: {
        eyebrow: "Bewertungen",
        title: "Das sagen unsere Gäste.",
        subtitle: "Stimmen unserer Gäste auf Google und Tripadvisor: Wer einmal kommt, kommt wieder.",
        basedOn: "Bewertungen",
        readOnGoogle: "Auf Google lesen",
        readOnTripadvisor: "Auf Tripadvisor lesen",
      },
      vicenza: {
        eyebrow: "Vicenza entdecken",
        title: "Die Stadt Palladios.",
        subtitle: "Eine Route durch UNESCO-Juwelen, nur wenige Schritte von unserem Tisch entfernt.",
        minutesAway: "Min. zu Fuß",
        readMore: "Mehr erfahren",
      },
      careers: {
        eyebrow: "Karriere",
        title: "Werde Teil des Harry's-Teams.",
        subtitle: "Wir suchen leidenschaftliche Mitarbeiter für Service, Küche und Bar. Senden Sie uns Ihre Bewerbung.",
        name: "Vor- und Nachname", email: "E-Mail", phone: "Telefon",
        position: "Gewünschte Position",
        positions: { hall: "Service", kitchen: "Küche", bartender: "Bar / Mixology", sommelier: "Sommelier", other: "Andere" },
        message: "Stellen Sie sich kurz vor",
        cv: "Lebenslauf anhängen (PDF, DOC, max. 5MB)",
        cvNote: "Nach dem Senden der WhatsApp-Nachricht hängen Sie Ihren Lebenslauf (PDF/DOC) als nächste Nachricht an.",
        cvAttached: "Lebenslauf angehängt",
        cvRemove: "Entfernen",
        viaWhatsapp: "Bewerbung über WhatsApp",
        submit: "Auf WhatsApp senden",
        success: "WhatsApp geöffnet: Senden Sie die Nachricht und hängen Sie dann Ihren Lebenslauf an.",
        error: "Fehler. Bitte später erneut versuchen.",
      },
      admin: {
        login: "Administrator-Login", email: "E-Mail", password: "Passwort", signin: "Anmelden",
        invalid: "Ungültige Anmeldedaten", logout: "Abmelden",
        dashboard: "Dashboard", menu: "Speisekarte", reservations: "Reservierungen", quotes: "Angebote", careers: "Bewerbungen",
        addItem: "Gericht hinzufügen", editItem: "Bearbeiten", deleteItem: "Löschen",
        category: "Kategorie", price: "Preis", available: "Verfügbar",
        save: "Speichern", cancel: "Abbrechen", confirm: "Löschen bestätigen?",
        status: "Status", pending: "Ausstehend", confirmed: "Bestätigt", rejected: "Abgelehnt",
        empty: "Keine Einträge", details: "Details", viewCv: "Lebenslauf ansehen",
      },
    },
  },
  fr: {
    translation: {
      nav: { home: "Accueil", menu: "Menu", gallery: "Galerie", reservation: "Réserver", quote: "Événements", location: "Nous trouver", vicenza: "Découvrir Vicence", careers: "Carrières", admin: "Admin" },
      hero: {
        eyebrow: "Au cœur de Vicence",
        title: "Élégance,\ngoût, convivialité.",
        subtitle: "Cuisine italienne raffinée et cocktails signature sur la Piazza Andrea Palladio. Une expérience où tradition et modernité se rencontrent.",
        ctaMenu: "Découvrir le Menu", ctaBook: "Réserver une table",
      },
      about: {
        eyebrow: "Notre histoire", title: "Un salon à table.",
        body: "Harry's Salotto e Cucina est un lieu accueillant au cœur de Vicence, où l'élégance et l'atmosphère conviviale se rencontrent. Nous proposons une cuisine soignée avec des plats sélectionnés, accompagnés de cocktails classiques et créatifs et d'une sélection de vins de qualité.",
        feature1Title: "Cuisine signature", feature1Body: "Tradition vénitienne réinterprétée avec élégance.",
        feature2Title: "Cocktails & Vins", feature2Body: "Étiquettes prestigieuses et mixologie contemporaine.",
        feature3Title: "Événements privés", feature3Body: "Groupes de 20, 30 ou 40 personnes dans un cadre exclusif.",
      },
      menu: {
        eyebrow: "La carte", title: "Notre menu",
        subtitle: "Une sélection saisonnière. Dépense moyenne : 20-30 € par personne.",
        categories: { antipasti: "Entrées", primi: "Pâtes", secondi: "Plats", pizza: "Pizza", burgers: "Burgers & Co", insalate: "Salades", contorni: "Accompagnements", dolci: "Desserts", cocktail: "Cocktails", vini: "Vins" },
        empty: "Aucun plat dans cette catégorie pour le moment.",
      },
      reservation: {
        eyebrow: "Réservation", title: "Réserver une table",
        subtitle: "Remplissez le formulaire : à la confirmation, WhatsApp s'ouvrira avec votre demande prête à envoyer.",
        viaWhatsapp: "Tout via WhatsApp",
        tabBook: "Réserver une table",
        tabQuote: "Événements privés",
        name: "Nom et prénom", email: "E-mail", phone: "Téléphone", date: "Date", time: "Heure",
        guests: "Convives", notes: "Notes (allergies, préférences...)",
        submit: "Envoyer sur WhatsApp", success: "WhatsApp ouvert : envoyez le message pour confirmer.",
        error: "Erreur lors de l'envoi. Réessayez.", required: "Champ obligatoire",
      },
      quote: {
        eyebrow: "Événements privés", title: "Demander un devis",
        subtitle: "Dîners d'entreprise, anniversaires, célébrations. Menu sur mesure pour groupes de 20 à 40 personnes.",
        name: "Nom et prénom", email: "E-mail", phone: "Téléphone",
        eventType: "Type d'événement", eventTypes: { birthday: "Anniversaire", corporate: "Entreprise", anniversary: "Célébration", wedding: "Mariage", other: "Autre" },
        guests: "Nombre de convives", date: "Date de l'événement", budget: "Budget indicatif (€/personne)",
        preferences: "Préférences culinaires, allergies, demandes particulières",
        submit: "Envoyer sur WhatsApp", success: "WhatsApp ouvert : envoyez le message pour recevoir le devis.",
      },
      location: {
        eyebrow: "Nous trouver", title: "Vicence, la cité de Palladio",
        subtitle: "À deux pas des principaux monuments UNESCO. Explorez la ville après le dîner.",
        address: "Adresse", phone: "Téléphone", hours: "Horaires",
        attractions: "Attractions à proximité", openInMaps: "Ouvrir dans Maps",
      },
      footer: { rights: "Tous droits réservés", contact: "Contact", links: "Liens" },
      gallery: {
        eyebrow: "Galerie",
        title: "Plats de notre cuisine.",
      },
      galleria: {
        eyebrow: "Galerie photos",
        title: "L'expérience Harry's.",
        subtitle: "Ambiance, plats, détails. Parcourez nos photos et plongez dans l'atmosphère du lieu.",
        empty: "Galerie bientôt disponible.",
      },
      reviews: {
        eyebrow: "Avis",
        title: "Ce qu'ils disent de nous.",
        subtitle: "Les voix de nos hôtes sur Google et Tripadvisor : ceux qui viennent reviennent.",
        basedOn: "avis",
        readOnGoogle: "Lire sur Google",
        readOnTripadvisor: "Lire sur Tripadvisor",
      },
      vicenza: {
        eyebrow: "Découvrir Vicence",
        title: "La cité de Palladio.",
        subtitle: "Un parcours de joyaux UNESCO à deux pas de notre table. Laissez-vous guider après le dîner.",
        minutesAway: "min à pied",
        readMore: "En savoir plus",
      },
      careers: {
        eyebrow: "Carrières",
        title: "Rejoignez l'équipe Harry's.",
        subtitle: "Nous recherchons des personnes passionnées pour la salle, la cuisine et le bar. Envoyez-nous votre candidature, nous vous recontacterons.",
        name: "Nom et prénom", email: "E-mail", phone: "Téléphone",
        position: "Poste recherché",
        positions: { hall: "Salle", kitchen: "Cuisine", bartender: "Bar / Mixologie", sommelier: "Sommelier", other: "Autre" },
        message: "Présentez-vous brièvement",
        cv: "Joindre votre CV (PDF, DOC, max 5 Mo)",
        cvNote: "Après avoir envoyé le message sur WhatsApp, joignez votre CV (PDF/DOC) en message suivant.",
        cvAttached: "CV joint",
        cvRemove: "Supprimer",
        viaWhatsapp: "Candidature via WhatsApp",
        submit: "Envoyer sur WhatsApp",
        success: "WhatsApp ouvert : envoyez le message puis joignez votre CV.",
        error: "Erreur. Réessayez plus tard.",
      },
      admin: {
        login: "Connexion administrateur", email: "E-mail", password: "Mot de passe", signin: "Se connecter",
        invalid: "Identifiants invalides", logout: "Déconnexion",
        dashboard: "Tableau de bord", menu: "Menu", reservations: "Réservations", quotes: "Devis", careers: "Candidatures",
        addItem: "Ajouter un plat", editItem: "Modifier", deleteItem: "Supprimer",
        category: "Catégorie", price: "Prix", available: "Disponible",
        save: "Enregistrer", cancel: "Annuler", confirm: "Confirmer la suppression ?",
        status: "Statut", pending: "En attente", confirmed: "Confirmé", rejected: "Refusé",
        empty: "Aucun élément", details: "Détails", viewCv: "Voir le CV",
      },
    },
  },
  es: {
    translation: {
      nav: { home: "Inicio", menu: "Menú", gallery: "Galería", reservation: "Reservar", quote: "Eventos", location: "Cómo llegar", vicenza: "Descubrir Vicenza", careers: "Empleo", admin: "Admin" },
      hero: {
        eyebrow: "En el corazón de Vicenza",
        title: "Elegancia,\nsabor, convivialidad.",
        subtitle: "Cocina italiana refinada y cócteles de autor en la Piazza Andrea Palladio. Una experiencia donde la tradición y la modernidad se encuentran.",
        ctaMenu: "Descubrir el Menú", ctaBook: "Reservar una mesa",
      },
      about: {
        eyebrow: "Nuestra historia", title: "Un salón a la mesa.",
        body: "Harry's Salotto e Cucina es un local acogedor en el corazón de Vicenza, donde la elegancia y el ambiente cordial se encuentran. Ofrecemos una cocina cuidada con platos seleccionados, acompañados de cócteles clásicos y creativos y una selección de vinos de calidad.",
        feature1Title: "Cocina de autor", feature1Body: "Tradición véneta reinterpretada con elegancia.",
        feature2Title: "Cócteles y Vinos", feature2Body: "Etiquetas selectas y coctelería contemporánea.",
        feature3Title: "Eventos privados", feature3Body: "Grupos de 20, 30 o 40 personas en un ambiente exclusivo.",
      },
      menu: {
        eyebrow: "La carta", title: "Nuestro menú",
        subtitle: "Una selección de temporada. Gasto medio: 20-30 € por persona.",
        categories: { antipasti: "Entrantes", primi: "Pastas", secondi: "Segundos", pizza: "Pizza", burgers: "Burgers & Co", insalate: "Ensaladas", contorni: "Guarniciones", dolci: "Postres", cocktail: "Cócteles", vini: "Vinos" },
        empty: "No hay platos en esta categoría por el momento.",
      },
      reservation: {
        eyebrow: "Reserva", title: "Reservar una mesa",
        subtitle: "Rellena el formulario: al confirmar, se abrirá WhatsApp con tu solicitud lista para enviar.",
        viaWhatsapp: "Todo a través de WhatsApp",
        tabBook: "Reservar mesa",
        tabQuote: "Eventos privados",
        name: "Nombre y apellido", email: "Email", phone: "Teléfono", date: "Fecha", time: "Hora",
        guests: "Comensales", notes: "Notas (alergias, preferencias...)",
        submit: "Enviar por WhatsApp", success: "WhatsApp abierto: envía el mensaje para confirmar.",
        error: "Error al enviar. Inténtalo de nuevo.", required: "Campo obligatorio",
      },
      quote: {
        eyebrow: "Eventos privados", title: "Solicitar presupuesto",
        subtitle: "Cenas de empresa, cumpleaños, aniversarios. Menú concertado para grupos de 20 a 40 personas.",
        name: "Nombre y apellido", email: "Email", phone: "Teléfono",
        eventType: "Tipo de evento", eventTypes: { birthday: "Cumpleaños", corporate: "Empresa", anniversary: "Aniversario", wedding: "Boda", other: "Otro" },
        guests: "Número de comensales", date: "Fecha del evento", budget: "Presupuesto orientativo (€/persona)",
        preferences: "Preferencias culinarias, alergias, peticiones especiales",
        submit: "Enviar por WhatsApp", success: "WhatsApp abierto: envía el mensaje para recibir el presupuesto.",
      },
      location: {
        eyebrow: "Cómo llegar", title: "Vicenza, la ciudad de Palladio",
        subtitle: "A pocos pasos de los principales monumentos UNESCO. Explora la ciudad después de cenar.",
        address: "Dirección", phone: "Teléfono", hours: "Horario",
        attractions: "Atracciones cercanas", openInMaps: "Abrir en Maps",
      },
      footer: { rights: "Todos los derechos reservados", contact: "Contacto", links: "Enlaces" },
      gallery: {
        eyebrow: "Galería",
        title: "Platos de nuestra cocina.",
      },
      galleria: {
        eyebrow: "Galería fotográfica",
        title: "La experiencia Harry's.",
        subtitle: "Ambiente, platos, detalles. Hojea nuestras fotos y sumérgete en el local.",
        empty: "Galería en camino.",
      },
      reviews: {
        eyebrow: "Reseñas",
        title: "Lo que dicen de nosotros.",
        subtitle: "Las voces de nuestros huéspedes en Google y Tripadvisor: quien viene una vez, vuelve.",
        basedOn: "reseñas",
        readOnGoogle: "Leer en Google",
        readOnTripadvisor: "Leer en Tripadvisor",
      },
      vicenza: {
        eyebrow: "Descubrir Vicenza",
        title: "La ciudad de Palladio.",
        subtitle: "Un recorrido por joyas UNESCO a pocos pasos de nuestra mesa. Déjate guiar después de cenar.",
        minutesAway: "min a pie",
        readMore: "Saber más",
      },
      careers: {
        eyebrow: "Empleo",
        title: "Únete al equipo Harry's.",
        subtitle: "Buscamos personas apasionadas para sala, cocina y bar. Envíanos tu candidatura, te contactaremos.",
        name: "Nombre y apellido", email: "Email", phone: "Teléfono",
        position: "Puesto de interés",
        positions: { hall: "Sala", kitchen: "Cocina", bartender: "Bar / Coctelería", sommelier: "Sumiller", other: "Otro" },
        message: "Preséntate brevemente",
        cv: "Adjunta tu CV (PDF, DOC, máx. 5MB)",
        cvNote: "Tras enviar el mensaje por WhatsApp, adjunta tu CV (PDF/DOC) como siguiente mensaje.",
        cvAttached: "CV adjunto",
        cvRemove: "Eliminar",
        viaWhatsapp: "Candidatura por WhatsApp",
        submit: "Enviar por WhatsApp",
        success: "WhatsApp abierto: envía el mensaje y luego adjunta tu CV.",
        error: "Error. Inténtalo más tarde.",
      },
      admin: {
        login: "Acceso administrador", email: "Email", password: "Contraseña", signin: "Acceder",
        invalid: "Credenciales no válidas", logout: "Salir",
        dashboard: "Panel", menu: "Menú", reservations: "Reservas", quotes: "Presupuestos", careers: "Candidaturas",
        addItem: "Añadir plato", editItem: "Editar", deleteItem: "Eliminar",
        category: "Categoría", price: "Precio", available: "Disponible",
        save: "Guardar", cancel: "Cancelar", confirm: "¿Confirmar eliminación?",
        status: "Estado", pending: "Pendiente", confirmed: "Confirmado", rejected: "Rechazado",
        empty: "Sin elementos", details: "Detalles", viewCv: "Ver CV",
      },
    },
  },
};

// Austrian variant — for now shares the German bundle. Admin can customize
// specific keys via the CMS (site_content collection) later.
resources.at = { translation: { ...resources.de.translation } };

// Arabic — right-to-left, focused on UI strings visitors see most.
resources.ar = {
  translation: {
    nav: { home: "الرئيسية", menu: "القائمة", gallery: "المعرض", reservation: "احجز", quote: "المناسبات", location: "أين نحن", vicenza: "زيارة فيتشنسا", careers: "الوظائف", admin: "المدير" },
    hero: {
      eyebrow: "في قلب فيتشنسا",
      title: "أناقة،\nذوق، ودفء الضيافة.",
      subtitle: "مطبخ إيطالي راقٍ وكوكتيلات مميزة في ساحة أندريا بالاديو. تجربة تلتقي فيها الأصالة بالحداثة.",
      ctaMenu: "استكشف القائمة", ctaBook: "احجز طاولة",
    },
    about: {
      eyebrow: "قصتنا", title: "صالون على الطاولة.",
      body: "هاريز سالوتو إي كوتشينا مكان أنيق ودافئ في قلب فيتشنسا، يلتقي فيه الرقي بأجواء الترحيب. نقدّم مطبخاً معتنى به بأطباق مختارة وكوكتيلات كلاسيكية ومبتكرة ومختارات مميزة من النبيذ.",
      feature1Title: "مطبخ مميز", feature1Body: "تراث فينيتو بلمسة عصرية أنيقة.",
      feature2Title: "كوكتيلات ونبيذ", feature2Body: "علامات مختارة ومزج معاصر.",
      feature3Title: "مناسبات خاصة", feature3Body: "مجموعات من 20 إلى 40 شخصاً في جو حصري.",
    },
    menu: {
      eyebrow: "القائمة", title: "قائمتنا",
      subtitle: "اختيارات موسمية. متوسط السعر: 20-30 يورو للشخص.",
      categories: { antipasti: "المقبلات", primi: "المعكرونة", secondi: "الأطباق الرئيسية", pizza: "بيتزا", burgers: "برجر", insalate: "سلطات", contorni: "أطباق جانبية", dolci: "الحلويات", cocktail: "كوكتيلات", vini: "النبيذ" },
      empty: "لا توجد أطباق في هذه الفئة حالياً.",
    },
    reservation: {
      eyebrow: "الحجز", title: "احجز طاولة",
      subtitle: "املأ النموذج: عند التأكيد، سيفتح واتساب برسالة جاهزة للإرسال.",
      viaWhatsapp: "كل شيء عبر واتساب",
      tabBook: "احجز طاولة",
      tabQuote: "مناسبات خاصة",
      name: "الاسم الكامل", email: "البريد", phone: "الهاتف", date: "التاريخ", time: "الوقت",
      guests: "عدد الضيوف", notes: "ملاحظات (حساسية، تفضيلات...)",
      submit: "أرسل عبر واتساب", success: "تم فتح واتساب: أرسل الرسالة للتأكيد.",
      error: "خطأ في الإرسال. أعد المحاولة.", required: "حقل مطلوب",
    },
    quote: {
      eyebrow: "مناسبات خاصة", title: "اطلب عرض سعر",
      subtitle: "عشاء الشركات، أعياد الميلاد، الاحتفالات. قائمة مخصصة لمجموعات من 20 إلى 40 شخصاً.",
      name: "الاسم الكامل", email: "البريد", phone: "الهاتف",
      eventType: "نوع المناسبة", eventTypes: { birthday: "عيد ميلاد", corporate: "شركة", anniversary: "احتفال", wedding: "زفاف", other: "أخرى" },
      guests: "عدد الضيوف", date: "تاريخ المناسبة", budget: "الميزانية التقريبية (يورو/شخص)",
      preferences: "التفضيلات، الحساسية، أي طلبات خاصة",
      submit: "أرسل عبر واتساب", success: "تم فتح واتساب: أرسل الرسالة لاستلام عرض السعر.",
    },
    location: {
      eyebrow: "أين نحن", title: "فيتشنسا، مدينة بالاديو",
      subtitle: "على بعد خطوات من أشهر معالم اليونسكو. استكشف المدينة بعد العشاء.",
      address: "العنوان", phone: "الهاتف", hours: "أوقات العمل",
      attractions: "معالم قريبة", openInMaps: "افتح في الخرائط",
    },
    footer: { rights: "جميع الحقوق محفوظة", contact: "اتصل بنا", links: "روابط" },
    gallery: {
      eyebrow: "المعرض",
      title: "أطباق من قائمتنا.",
    },
    galleria: {
      eyebrow: "معرض الصور",
      title: "تجربة هاريز.",
      subtitle: "الأجواء، الأطباق، التفاصيل. تصفح صورنا وانغمس في أجواء المكان.",
      empty: "المعرض قادم قريباً.",
    },
    vicenza: {
      eyebrow: "اكتشف فيتشنسا",
      title: "مدينة بالاديو.",
      subtitle: "جولة بين درر اليونسكو على بعد خطوات من طاولتنا. دعنا نرشدك بعد العشاء.",
      minutesAway: "دقائق سيراً",
      readMore: "اقرأ المزيد",
    },
    careers: {
      eyebrow: "الوظائف",
      title: "انضم إلى فريق هاريز.",
      subtitle: "نبحث عن أشخاص شغوفين للصالة والمطبخ والبار. أرسل لنا سيرتك الذاتية وسنعاود الاتصال بك.",
      name: "الاسم الكامل", email: "البريد", phone: "الهاتف",
      position: "الوظيفة المطلوبة",
      positions: { hall: "خدمة الصالة", kitchen: "المطبخ", bartender: "البار / كوكتيلات", sommelier: "سومولييه", other: "أخرى" },
      message: "قدّم نفسك باختصار",
      cv: "أرفق سيرتك الذاتية (PDF، DOC، حتى 5 ميجابايت)",
      cvNote: "بعد إرسال الرسالة عبر واتساب، أرفق سيرتك الذاتية كرسالة تالية.",
      cvAttached: "السيرة الذاتية مرفقة",
      cvRemove: "إزالة",
      viaWhatsapp: "قدّم طلبك عبر واتساب",
      submit: "أرسل عبر واتساب",
      success: "تم فتح واتساب: أرسل الرسالة ثم أرفق سيرتك الذاتية.",
      error: "خطأ. أعد المحاولة لاحقاً.",
    },
    admin: {
      login: "تسجيل دخول المدير", email: "البريد", password: "كلمة المرور", signin: "دخول",
      invalid: "بيانات غير صحيحة", logout: "خروج",
      dashboard: "لوحة التحكم", menu: "القائمة", reservations: "الحجوزات", quotes: "عروض الأسعار", careers: "الطلبات",
      addItem: "إضافة طبق", editItem: "تعديل", deleteItem: "حذف",
      category: "الفئة", price: "السعر", available: "متوفر",
      save: "حفظ", cancel: "إلغاء", confirm: "تأكيد الحذف؟",
      status: "الحالة", pending: "قيد الانتظار", confirmed: "مؤكد", rejected: "مرفوض",
      empty: "لا توجد عناصر", details: "التفاصيل", viewCv: "عرض السيرة",
    },
    reviews: {
      eyebrow: "المراجعات",
      title: "ماذا يقول ضيوفنا.",
      subtitle: "أصوات ضيوفنا على جوجل وتريب أدفايزور.",
      basedOn: "مراجعة",
      readOnGoogle: "اقرأ على جوجل",
      readOnTripadvisor: "اقرأ على تريب أدفايزور",
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("lang") || "it",
  fallbackLng: "it",
  interpolation: { escapeValue: false },
});

// Apply RTL direction whenever Arabic is selected
const applyDir = (lng) => {
  document.documentElement.setAttribute("dir", lng === "ar" ? "rtl" : "ltr");
  document.documentElement.setAttribute("lang", lng);
};
applyDir(i18n.language);
i18n.on("languageChanged", applyDir);

export default i18n;
